export default __webpack_public_path__ + "static/arrow-386678e0584218ebd41fb8b4d23b46a1.svg";